import { render, staticRenderFns } from "./CockpitPrepostUser.vue?vue&type=template&id=22b12047"
import script from "./CockpitPrepostUser.vue?vue&type=script&lang=js"
export * from "./CockpitPrepostUser.vue?vue&type=script&lang=js"
import style0 from "./CockpitPrepostUser.vue?vue&type=style&index=0&id=22b12047&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports